<div class="space-x-2 flex flex-nowrap items-center flex-shrink-0">
  @if (panelMode() && wizardMode()) {
    <button
      pButton
      icon="pi pi-chevron-left"
      class="p-button-sm"
      [outlined]="true"
      severity="secondary"
      (click)="wizardPrevStep.emit()"
      [disabled]="!canGoPrevWizardStep()"
      tooltipPosition="left"
    ></button>
    <button
      type="button"
      class="wizard-step-label text-xs whitespace-nowrap px-2 py-1 rounded cursor-pointer border-0"
      (click)="onStepLabelClick($event)"
      pTooltip="Jump to step"
      tooltipPosition="bottom"
    >
      Step {{ wizardStepIndex() + 1 }} / {{ wizardTotalSteps() }} &mdash; {{ wizardStepLabel() }}
    </button>
    <p-popover #stepListPopover appendTo="body">
      <ul class="list-none m-0 p-0 max-h-[400px] overflow-auto min-w-[220px]">
        @for (label of wizardStepLabels(); track $index) {
          <li>
            <button
              type="button"
              class="wizard-step-item w-full text-left px-3 py-2 text-sm border-0 border-l-2 border-l-transparent cursor-pointer rounded"
              [class.is-active]="$index === wizardStepIndex()"
              [class.bg-surface-100]="$index === wizardStepIndex()"
              [class.dark:bg-surface-800]="$index === wizardStepIndex()"
              [class.border-l-primary-500]="$index === wizardStepIndex()"
              [class.font-semibold]="$index === wizardStepIndex()"
              [class.text-primary-600]="$index === wizardStepIndex()"
              [class.dark:text-primary-400]="$index === wizardStepIndex()"
              (click)="selectStep($index, $event)"
            >
              <span class="text-xs opacity-70 mr-2">{{ $index + 1 }}.</span>{{ label }}
            </button>
          </li>
        }
      </ul>
    </p-popover>
    <button
      pButton
      icon="pi pi-chevron-right"
      class="p-button-sm"
      [outlined]="true"
      severity="secondary"
      (click)="wizardNextStep.emit()"
      [disabled]="!canGoNextWizardStep()"
      tooltipPosition="bottom"
    ></button>
  }

  <button
    pButton
    [icon]="wizardMode() ? 'pi pi-bolt' : 'pi pi-bolt'"
    class="p-button-sm"
    [outlined]="true"
    [severity]="wizardMode() ? 'info' : 'secondary'"
    (click)="wizardToggle.emit()"
    [pTooltip]="wizardMode() ? 'Exit Wizard Mode' : 'Enter Wizard Mode'"
    tooltipPosition="bottom"
  ></button>

  <p-splitButton
    class="mb-1"
    icon="pi pi-objects-column"
    (onClick)="panelToggle.emit()"
    [model]="panelColumnItems()"
    [outlined]="true"
    size="small"
    [severity]="!wizardMode() && panelMode() ? 'info' : 'secondary'"
    pTooltip="Toggle Panel Mode"
    tooltipPosition="bottom"
    appendTo="body"
  ></p-splitButton>

  <button
    pButton
    icon="pi pi-calculator"
    class="p-button-sm p-button-text p-button-secondary"
    (click)="unitsConverterOpen.emit()"
    pTooltip="Units Converter"
    tooltipPosition="bottom"
  ></button>

  <p-multiSelect
    #search
    [filter]="true"
    [autofocusFilter]="true"
    panelStyleClass="multiSelectClassNoCheckbox"
    resetFilterOnHide="true"
    [(ngModel)]="selectedItems"
    placeholder="Search"
    [showToggleAll]="false"
    (onChange)="onComponentAdded($event)"
    (onFilter)="handleFilter($event)"
    optionLabel="displayLabel"
    (onBlur)="handleFilter({ filter: '' })"
    (onFocus)="populate()"
    appendTo="body"
    [options]="filteredComponents()">

    <ng-template let-component pTemplate="item">
      <div>
        @if (filteredName(component) && !filteredProperty(component)) {
          <label>{{ component.name }}</label>
        }
        @if (filteredProperty(component)) {
          <strong>{{ component.name }}</strong>
        }
        @if (filteredProperty(component) || filteredName(component)) {
          <div>
            @if (componentContainsProperty(component)) {
              <small>Property: {{ filteredProperty(component) }}</small>
            }
          </div>
        }
      </div>
    </ng-template>
  </p-multiSelect>

      <p-button size="small" [text]="true" (click)="schematicToggled.emit()">
        <span class="hidden lg:inline">Well Schematic</span>
        <img class="img well-icon h-[25px]" src="../../assets/icons/Schematic.png" />
      </p-button>
</div>
